<span class="title" [ngClass]="color">
  {{ (required ? "*" : "") + " " + label }}
</span>
